import React from 'react';
import { Modal, Col, Button } from 'react-bootstrap';
import l10n from 'localization/LocalizationData';

interface ExitModalProps {
	show: boolean;
	accept: () => void;
	decline: () => void;
}
export const ExitModal = (props: ExitModalProps) => {
	return (
		<Modal aria-labelledby='exitQuestionnaireTitle' show={props.show} onHide={() => { }}>
			<Modal.Header closeButton={true}>
				<Modal.Title id='exitQuestionnaireTitle'>{l10n.endQuestionnaire_title}</Modal.Title>
			</Modal.Header>
			<Modal.Footer className='justify-content-center'>
				<Col xs='auto'>
					<Button variant="primary" onClick={props.decline}>
						{l10n.button_no}
					</Button>
				</Col>
				<Col xs='auto'>
					<Button variant="primary" onClick={props.accept}>
						{l10n.button_yes}
					</Button>
				</Col>
			</Modal.Footer>
		</Modal>
	);
}